import { render, staticRenderFns } from "./freightEdit.vue?vue&type=template&id=d79fbe9a&scoped=true&"
import script from "./freightEdit.vue?vue&type=script&lang=js&"
export * from "./freightEdit.vue?vue&type=script&lang=js&"
import style0 from "./freightEdit.vue?vue&type=style&index=0&id=d79fbe9a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79fbe9a",
  null
  
)

export default component.exports